import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Modal, Button } from 'components/shared';
import { theme } from 'styles';

const { colors } = theme;

const StyledWrapper = styled.div`
  background: #ffffff;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 10px;
`;

const Header = styled.h2`
  font-weight: bold;
  font-size: 36px;
  margin-bottom: 10px;
`;

const Copy = styled.p`
  font-size: 18px;
  margin-bottom: 10px;
`;

const KeepShopping = styled.div`
  margin-top: 10px;
  text-decoration: underline;
  color: ${colors.blue};
`;

function GoToPlatformModal(props) {
  return (
    <Modal {...props}>
      <StyledWrapper>
        <Header>One More Thing...</Header>
        <Copy>Login to complete your purchase.</Copy>
        <Button href={process.env.GATSBY_MARKETTAP_PLATFORM_CLIENT_HOST}>
          Login
        </Button>
        <KeepShopping>
          <button onClick={props.onRequestClose}>Continue exploring</button>
        </KeepShopping>
      </StyledWrapper>
    </Modal>
  );
}

GoToPlatformModal.propTypes = {
  onRequestClose: PropTypes.func.isRequired,
};

export default GoToPlatformModal;



// WEBPACK FOOTER //
// ./src/components/shared/GoToPlatformModal/GoToPlatformModal.jsx